import { get } from 'lodash'

import { Manifestation, getTranslatedString } from '@skinsoft/types'

export const id = (manifestation: Manifestation) => get(manifestation, 'id');

export const expression = (manifestation: Manifestation) => {
    return get(manifestation, ['linkToExpression', 'referentExpression', 'ref']) ??
        get(manifestation, ['linkToExpression', 'referentExpression']) 
}

export const title = (manifestation: Manifestation, locale: string) => getTranslatedString(get(manifestation, 'descriptionSchema.titles[0].title'), locale)

export const domain = (manifestation: Manifestation) => get(manifestation, 'descriptionSchema.domain[0]')

export const name = (manifestation: Manifestation) => get(manifestation, 'descriptionSchema.name[0]')

export const materialsAndTechnics = (manifestation: Manifestation) => get(manifestation, 'descriptionSchema.materialAndTechniques')

export const measurements = async (manifestation: Manifestation) => get(manifestation, 'descriptionSchema.measurements')